module.exports = __webpack_public_path__ + "static/media/cover_blog_new.9067fbc6.png";